namespace Matrix.Data {
    export interface FxRateForm {
        FromCurrency: FormatLookupEditor;
        ToCurrency: FormatLookupEditor;
        SourceCode: Serenity.LookupEditor;
        InstanceCode: Serenity.LookupEditor;
        AsAtDate: Serenity.DateEditor;
        RateMultiplier: Serenity.DecimalEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class FxRateForm extends Serenity.PrefixedContext {
        static formKey = 'Data.FxRate';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FxRateForm.init)  {
                FxRateForm.init = true;

                var s = Serenity;
                var w0 = FormatLookupEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(FxRateForm, [
                    'FromCurrency', w0,
                    'ToCurrency', w0,
                    'SourceCode', w1,
                    'InstanceCode', w1,
                    'AsAtDate', w2,
                    'RateMultiplier', w3,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
